module.exports = __webpack_public_path__ + "456b9bfb54852ac47273e015938ed05d.svg";